import { render } from "./ForgotPassword.vue?vue&type=template&id=388dd337&ts=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"

import "./ForgotPassword.vue?vue&type=style&index=0&id=388dd337&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__